import { gql } from '@apollo/client';

const GET_MDDAP_ORG_UNIT_PROGRAM_YEARS = gql`
  query GetMddapOrgUnitProgramYears($id: Int!) {
    mddapOrgUnitProgramYears(id: $id) {
      AppraisalProgramYear
      AppraisalId
    }
  }
`;

export default GET_MDDAP_ORG_UNIT_PROGRAM_YEARS;
